import { SubordersTable } from "@/components/stock/suborders-table";
import { useOrder } from "@/hooks/use-order";
import type { OrderPanelBaseProps } from "../../shared";

export function OrderSuborders({ orderId }: OrderPanelBaseProps) {
	/** Query */
	const { refetch } = useOrder(orderId);

	/** Render */
	return (
		<SubordersTable
			type="table"
			orderId={orderId}
			refetch={refetch}
		/>
	);
}
